<template>
  <Modal
    v-model="_value"
    width="500"
    title="添加定位设备信息"
    @on-visible-change="visibleChange"
    ok-text="添加"
    @on-ok="onOk">
    <div style="height: 620px;border: 1px solid #dcdee2;">
      <Split v-model="split1">
        <div slot="left" class="demo-split-pane">
    <Form ref="loginForm" :model="positioningDeviceInfo" :rules="rules">
      <FormItem prop="terminalNum">
        <Input v-model="positioningDeviceInfo.terminalNum" placeholder="请输入主机号">
        </Input>
          <span style="color: red">接入设备使用原主机号</span>
      </FormItem>
      <FormItem prop="positioningDeviceModel">
        <Select placeholder="选择SIM卡"
                v-model="simInfosid"
                multiple
                filterable
                remote
                :remote-method="selectSIMInfos"
        >
          <Option v-for="(option, index) in simInfosOptions" :value="option.id" :key="option.id">{{option.simNum+'('+option.remark+')'}}</Option>
        </Select>
          <span style="color: red">必填，新SIM卡后7位查询</span>
      </FormItem>
      <FormItem prop="factoryTerminalNum">
        <Input v-model="positioningDeviceInfo.factoryTerminalNum" placeholder="请输入出厂主机号">
        </Input>
      </FormItem>
      <FormItem prop="firmware">
        <Input type="textarea" v-model="positioningDeviceInfo.firmware" placeholder="请输入固件版本号">
        </Input>
      </FormItem>
      <FormItem prop="positioningDeviceModel">
        <Select placeholder="选择设备型号"
                v-model="positioningDeviceInfo.positioningDeviceModelId"
                @on-change="selectPositioningDeviceInfoaisle"
        >
          <Option v-for="(option, index) in positioningDeviceModelOptions" :value="option.id" :key="option.id">{{option.name+'('+option.manufacturer+')'}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="sourceType">
        <Select placeholder="选择设备来源"
                v-model="positioningDeviceInfo.sourceType"
        >
          <Option v-for="(option, index) in positioningDeviceSourceTypeOptions" :value="option.value" :key="option.label">{{option.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="encryptionChipNumber">
        <Input v-model="positioningDeviceInfo.encryptionChipNumber" placeholder="请输入加密芯片号">
        </Input>
      </FormItem>
      <FormItem prop="remark">
        <Input type="textarea" v-model="positioningDeviceInfo.remark" placeholder="备注">
        </Input>
      </FormItem>
    </Form>
        </div>
        <div slot="right" class="demo-split-pane">
          <Scroll height="400">
        <CheckboxGroup>
          <Checkbox size="large" label="摄像头通道-1" class="Checkbox" v-model="positioningDeviceInfo.aisleOne"></Checkbox><br>
          <Checkbox size="large" label="摄像头通道-2" class="Checkbox" v-model="positioningDeviceInfo.aisleTwo"></Checkbox><br>
          <Checkbox size="large" label="摄像头通道-3" class="Checkbox" v-model="positioningDeviceInfo.aisleThree"></Checkbox><br>
          <Checkbox size="large" label="摄像头通道-4" class="Checkbox" v-model="positioningDeviceInfo.aisleFour"></Checkbox><br>
          <Checkbox size="large" label="摄像头通道-5" class="Checkbox" v-model="positioningDeviceInfo.aisleFive"></Checkbox><br>
          <Checkbox size="large" label="摄像头通道-6" class="Checkbox" v-model="positioningDeviceInfo.aisleSix"></Checkbox><br>
          <Checkbox size="large" label="摄像头通道-7" class="Checkbox" v-model="positioningDeviceInfo.aisleSeven"></Checkbox><br>
          <Checkbox size="large" label="摄像头通道-8" class="Checkbox" v-model="positioningDeviceInfo.aisleEight"></Checkbox><br>
          <Checkbox size="large" label="摄像头通道-9" class="Checkbox" v-model="positioningDeviceInfo.aisleNine"></Checkbox><br>
          <Checkbox size="large" label="摄像头通道-10" class="Checkbox" v-model="positioningDeviceInfo.aisleTen"></Checkbox><br>
        </CheckboxGroup>
          </scroll>
        </div>
      </Split>
    </div>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'AddPositioningDeviceInfoModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    simNumRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: 'SIM卡号码不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  data () {
    return {
      // 分割面板
      split1: 0.5,

      positioningDeviceInfoStateOptions: [
        { label: '未安装', value: 1 },
        { label: '已安装', value: 2 },
        { label: '损坏', value: 3 }
      ],
      simInfosOptions:[],
      positioningDeviceModelOptions: [
        // { label: 'BSJ-A6-BD', value: 1 },
        // { label: 'BSJ-GF03', value: 2 },
        // { label: 'BSJ-M11', value: 3 },
        // { label: 'BSJ-A6L', value: 13 },
        // { label: 'BSJ-A7', value: 14 },
        // { label: 'K5', value: 4 },
        // { label: 'D5X', value: 5 },
        // { label: 'G-3G', value: 6 },
        // { label: 'D5X-HDD', value: 7 },
        // { label: 'D5X-XR', value: 8 },
        // { label: 'BSJ-GF06', value: 9 },
        // { label: 'BSJ-RM01', value: 10 },
        // { label: 'HIK-A3', value: 11 },
        // { label: 'HIK-A3L', value: 12 }
      ],
      positioningDeviceSourceTypeOptions: [
        { label: '新装', value: 1 },
        { label: '接入', value: 2 }
      ],

      positioningDeviceInfo: {
        terminalNum: null,
        factoryTerminalNum: null,
        positioningDeviceModel: null,
        positioningDeviceModelId: null,
        sourceType: null,
        firmware: null,
        encryptionChipNumber: null,
        remark: null,
        aisleOne: null,
        aisleTwo: null,
        aisleThree: null,
        aisleFour: null,
        aisleFive: null,
        aisleSix: null,
        aisleSeven: null,
        aisleEight: null,
        aisleNine: null,
        aisleTen: null
      },
      simInfosid:[],
    }
  },
  methods: {
    ...mapActions([
      'PositioningDeviceInfoServ_AddObj'
    ]),
    onOk () {
      if (this.simInfosid == null || this.simInfosid ==""){
        this.$Message.error('请填写SIM卡资料')
        return;
      }
      this.$Modal.confirm({
        title: '添加定位设备信息',
        content: '<p>是否确认添加定位设备信息</p>',
        onOk: () => {
          store.dispatch('PositioningDeviceInfoServ_AddObj', { params: this.positioningDeviceInfo }).then(() => {
            this.$Message.success('添加定位设备信息成功')
            this.$emit('on-success')

            store.dispatch('PositioningDeviceInfoServ_BindSimInfos', {
              params: {id: store.getters.get_PositioningDeviceInfo_AddObjResult.id, simInfoIds: this.simInfosid}
            }).then(() => {
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {
        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.positioningDeviceInfo.terminalNum = null
        this.positioningDeviceInfo.factoryTerminalNum = null
        this.positioningDeviceInfo.positioningDeviceModel = null
        this.positioningDeviceInfo.positioningDeviceModelId = null
        this.positioningDeviceInfo.sourceType = null
        this.positioningDeviceInfo.firmware = null
        this.positioningDeviceInfo.encryptionChipNumber = null
        this.positioningDeviceInfo.remark = null
        this.positioningDeviceInfo.aisleOne = false
        this.positioningDeviceInfo.aisleTwo = false
        this.positioningDeviceInfo.aisleThree = false
        this.positioningDeviceInfo.aisleFour = false
        this.positioningDeviceInfo.aisleFive = false
        this.positioningDeviceInfo.aisleSix = false
        this.positioningDeviceInfo.aisleSeven = false
        this.positioningDeviceInfo.aisleEight = false
        this.positioningDeviceInfo.aisleNine = false
        this.positioningDeviceInfo.aisleTen = false

        store.dispatch('PositioningDeviceTypeServ_GetAll', {
          params: {},
          urlparams: null
        }).then(() => {
          this.positioningDeviceModelOptions = store.getters.get_PositioningDeviceType_GetAllResult
        }).catch(err => {
          console.log(err)
        })
      }
    },
    selectSIMInfos(input){
      if (!input || input.length <= 0) {
        this.simInfosOptions = []
      } else {
        store.dispatch('SimInfoServ_SearchByName', {
          params: {name: input},
          urlparams: null
        }).then(() => {
          this.simInfosOptions = store.getters.get_SimInfo_SearchByNameResult ? store.getters.get_SimInfo_SearchByNameResult : []
        }).catch(err => {
          console.log(err)
        })
      }
    },
    selectPositioningDeviceInfoaisle (data) {
      console.log(data)
      if (data) {
        /**
         * 根据选择类型，默认匹配摄像头搭配
         */
        store.dispatch('PositioningDeviceTypeServ_GetDetail', {
          params: {
            id: data
          },
          urlparams: null
        }).then(res => {
          console.log(res)
          if (store.getters.get_PositioningDeviceType_GetDetailResult.adas) {
            if (store.getters.get_PositioningDeviceType_GetDetailResult.manufacturer === '杭州海康汽车技术有限公司') {
              this.positioningDeviceInfo.aisleOne = true
              this.positioningDeviceInfo.aisleTwo = true
              this.positioningDeviceInfo.aisleThree = false
              this.positioningDeviceInfo.aisleFour = true
              this.positioningDeviceInfo.aisleFive = false
              this.positioningDeviceInfo.aisleSix = false
              this.positioningDeviceInfo.aisleSeven = false
              this.positioningDeviceInfo.aisleEight = false
              this.positioningDeviceInfo.aisleNine = false
              this.positioningDeviceInfo.aisleTen = false
            }
            if (store.getters.get_PositioningDeviceType_GetDetailResult.manufacturer === '深圳市锐明技术股份有限公司') {
              if (store.getters.get_PositioningDeviceType_GetDetailResult.manufacturername == 'D5X') {
                this.positioningDeviceInfo.aisleOne = false
                this.positioningDeviceInfo.aisleTwo = false
                this.positioningDeviceInfo.aisleThree = false
                this.positioningDeviceInfo.aisleFour = false
                this.positioningDeviceInfo.aisleFive = true
                this.positioningDeviceInfo.aisleSix = true
                this.positioningDeviceInfo.aisleSeven = false
                this.positioningDeviceInfo.aisleEight = false
                this.positioningDeviceInfo.aisleNine = false
                this.positioningDeviceInfo.aisleTen = false
              } else if (store.getters.get_PositioningDeviceType_GetDetailResult.manufacturername == 'D5X_HDD') {
                this.positioningDeviceInfo.aisleOne = true
                this.positioningDeviceInfo.aisleTwo = true
                this.positioningDeviceInfo.aisleThree = false
                this.positioningDeviceInfo.aisleFour = false
                this.positioningDeviceInfo.aisleFive = false
                this.positioningDeviceInfo.aisleSix = false
                this.positioningDeviceInfo.aisleSeven = false
                this.positioningDeviceInfo.aisleEight = false
                this.positioningDeviceInfo.aisleNine = true
                this.positioningDeviceInfo.aisleTen = true
              } else if (store.getters.get_PositioningDeviceType_GetDetailResult.manufacturername = ('D5X_XR')) {
                this.positioningDeviceInfo.aisleOne = true
                this.positioningDeviceInfo.aisleTwo = true
                this.positioningDeviceInfo.aisleThree = false
                this.positioningDeviceInfo.aisleFour = true
                this.positioningDeviceInfo.aisleFive = false
                this.positioningDeviceInfo.aisleSix = false
                this.positioningDeviceInfo.aisleSeven = false
                this.positioningDeviceInfo.aisleEight = false
                this.positioningDeviceInfo.aisleNine = false
                this.positioningDeviceInfo.aisleTen = false
              }
            }
            if (store.getters.get_PositioningDeviceType_GetDetailResult.manufacturer === '江苏中天安驰科技有限公司') {
              if (store.getters.get_PositioningDeviceType_GetDetailResult.manufacturername == 'P9S') {
                this.positioningDeviceInfo.aisleOne = true
                this.positioningDeviceInfo.aisleTwo = true
                this.positioningDeviceInfo.aisleThree = true
                this.positioningDeviceInfo.aisleFour = false
                this.positioningDeviceInfo.aisleFive = false
                this.positioningDeviceInfo.aisleSix = false
                this.positioningDeviceInfo.aisleSeven = false
                this.positioningDeviceInfo.aisleEight = false
                this.positioningDeviceInfo.aisleNine = false
                this.positioningDeviceInfo.aisleTen = false
              }else if (store.getters.get_PositioningDeviceType_GetDetailResult.manufacturername = ('W5')) {
                this.positioningDeviceInfo.aisleOne = true
                this.positioningDeviceInfo.aisleTwo = true
                this.positioningDeviceInfo.aisleThree = false
                this.positioningDeviceInfo.aisleFour = false
                this.positioningDeviceInfo.aisleFive = false
                this.positioningDeviceInfo.aisleSix = false
                this.positioningDeviceInfo.aisleSeven = false
                this.positioningDeviceInfo.aisleEight = false
                this.positioningDeviceInfo.aisleNine = false
                this.positioningDeviceInfo.aisleTen = false
              }
            }
            if (store.getters.get_PositioningDeviceType_GetDetailResult.manufacturer === '惠州市博实结科技有限公司') {
              if (store.getters.get_PositioningDeviceType_GetDetailResult.manufacturername == 'BSJ-GH03T') {
                this.positioningDeviceInfo.aisleOne = true
                this.positioningDeviceInfo.aisleTwo = false
                this.positioningDeviceInfo.aisleThree = true
                this.positioningDeviceInfo.aisleFour = false
                this.positioningDeviceInfo.aisleFive = false
                this.positioningDeviceInfo.aisleSix = false
                this.positioningDeviceInfo.aisleSeven = false
                this.positioningDeviceInfo.aisleEight = false
                this.positioningDeviceInfo.aisleNine = false
                this.positioningDeviceInfo.aisleTen = false
              }
            }
          }else {
            this.positioningDeviceInfo.aisleOne = false
            this.positioningDeviceInfo.aisleTwo = false
            this.positioningDeviceInfo.aisleThree = false
            this.positioningDeviceInfo.aisleFour = false
            this.positioningDeviceInfo.aisleFive = false
            this.positioningDeviceInfo.aisleSix = false
            this.positioningDeviceInfo.aisleSeven = false
            this.positioningDeviceInfo.aisleEight = false
            this.positioningDeviceInfo.aisleNine = false
            this.positioningDeviceInfo.aisleTen = false
          }
        }).catch(err => {
          console.log(err)
        })
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    rules () {
      return {
        simNum: this.simNumRules
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
